<router-outlet name="primary"></router-outlet>
<lib-toastify-toast-container
    position= 'bottom-right'
    [hideProgressBar]= true
    [autoClose]= 5000
    iconLibrary= 'material'
></lib-toastify-toast-container>
